import * as React from 'react';
import { useState, useRef,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { BASE_URL } from "../../App";
import CustomTextField from "./Numerictext";
import Stack from '@mui/material/Stack';
import CustomButton from "./CustomButton";
import Swal from 'sweetalert2';
import Avatar from '@mui/material/Avatar';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'; // Assuming you're using react-icons for icons
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import InputAdornment from '@mui/material/InputAdornment';
import Crilogo from '../image/CRIOvalLogo.jpg';
import {  List, ListItem, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import Badge from '@mui/material/Badge';


export default function ButtonAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false); // State for modal
  const [newPassword, setNewPassword] = useState(''); // State for new password input
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const [userProfile, setUserProfile] = useState(null);
  const [profileImage, setProfileImage] = useState([]);
  const [IsValid, setIsValid] = useState(null);
  const [currentDirectoryName, setCurrentDirectoryName] = useState('');
  const login_id = localStorage.getItem("LOGIN_ID");
  const USER_ID = localStorage.getItem("USER_ID");
  const usertype = localStorage.getItem("usertype");
  const USER_NAME = localStorage.getItem("USER_NAME");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filteredList, setFilteredList] = useState([]);
  const [showList, setShowList] = useState(false);
  const dropdownRef = useRef(null); // Reference for dropdown
  const [menuAnchor, setMenuAnchor] = useState(null);
const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);
  const isMenuOpen = Boolean(menuAnchor);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };
  const handleClick = (path, newTab) => {
    if (newTab === "1") {
      // Open in a new tab
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      // Navigate within the app
      navigate(path);
      setShowList(false); // Close the list after navigation
    }
  };
  const [editedPassword, setEditedPassword] = useState({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
  });
useEffect(() => {
  if (usertype == "3") {
    notification_api();
    // Refresh every 5 minutes (adjust as needed)
    const interval = setInterval(notification_api, 300000);
    return () => clearInterval(interval);
  }
}, [usertype]);
const notification_api = async () => {
  try {
    const response = await axios.post(BASE_URL + '/DMS_Notification', { Login_ID: login_id });
    
    if (response.data && response.data.data) {
      const notificationData = response.data.data;
      
      // Ensure notifications is always an array
      setNotifications(Array.isArray(notificationData.message) ? notificationData.message : []);
      setUnreadCount(parseInt(notificationData.message_count, 10) || 0);
    } else {
      setNotifications([]);
      setUnreadCount(0);
    }
  } catch (error) {
    console.error('Error fetching notifications:', error);
    setNotifications([]);
    setUnreadCount(0);
  }
};

 

  // const togglePasswordVisibility = () => {
  //     setShowPassword(!showPassword);
  // };

  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };
  
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const [errorMsg, setErrorMsg] = useState('');


  useEffect(() => {
    if (login_id) {
      fetchData();
      fetchData1();
    }
  }, [login_id]);
  
  const fetchData1 = async () => {
    try {
      const response = await axios.post(BASE_URL + '/searchmenuList', {
        login_id: login_id,
      });
      console.log('API Response:', response.data.searchlist);
      setData(response.data.searchlist);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowList(false);
      
      }
    };

    if (showList) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showList]);
  const fetchData = async () => {
    setUserProfile('');
    try {
      const response = await axios.post(BASE_URL + '/getemployeeprofiledetails', { login_id });
  
      if (response.data.status === "200" && response.data.userprofile.length > 0) {
        setUserProfile(response.data.userprofile[0]);
      } else {
        console.error('No user profile found or status is not 200');
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  useEffect(() => {

    const pathname = location.pathname;
    const parts = pathname.split('/').filter(part => part.trim() !== '');
    if (parts.length > 0) {
      const lastDirectoryName = parts[parts.length - 1];
      const modifiedDirectoryName = lastDirectoryName.replace(/_/g, ' ');
      setCurrentDirectoryName(modifiedDirectoryName);
    }
  }, [location.pathname]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
const handleNotificationClick = async (notification) => {
  try {
    // Call the API to mark notification as opened
    await axios.post(BASE_URL + '/DMS_Notification_Open', {
      MessageID: notification.MessageID,
      Login_ID: login_id
    });

    // Refresh notifications after marking as read
    await notification_api();

    // Navigate to the relevant path if specified
    if (notification.path) {
      navigate(`/${notification.path}?doc_number=${notification.doc_number}`);
    }
  } catch (error) {
    console.error('Error handling notification click:', error);
    // Swal.fire({
    //   icon: "error",
    //   title: "Error",
    //   text: "Failed to update notification status"
    // });
  }
};
  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/Login");
    handleProfileMenuClose();
  };

  const handleUpdatePasswordClick = () => {
    setOpenModal(true); // Open the modal when "Update Password" is clicked
    handleProfileMenuClose(); // Close the profile menu
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setEditedPassword({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
  });
  setErrorMsg('');

  };

  const handleUpdatePassword = async () => {
    try {
      if (newPassword.length < 8) {
        console.error('Password must be at least 8 characters long.');
        return;
      }
      const response = await axios.post(BASE_URL + '/updatepassword', {
        login_id,
        newPassword: newPassword
      });
console.log('Password updated successfully:', response.data);
      handleModalClose();
    } catch (error) {
      console.error('Error updating password:', error);
    }
  };

  const handlePasswordChange = (event) => {
    setNewPassword(event.target.value);
  };
  const getColorForLetter = (letter) => {
    const colors = [
      '#327da8', '#ff5733', '#33ff57', '#5733ff', '#ff3399', '#3399ff', '#ffcc33', '#33ffcc', '#cc33ff',
      '#ffff33', '#33ffff', '#ff3333', '#33ff33', '#3333ff', '#ff33ff', '#33ff33', '#33ff33', '#33ff33',
      '#33ff33', '#33ff33', '#33ff33', '#33ff33', '#33ff33', '#33ff33', '#33ff33', '#33ff33'
    ];
    const index = letter.toUpperCase().charCodeAt(0) - 65; // Assuming uppercase letters only
    return colors[index % colors.length];
  };

  const validatePassword = (input) => {
    const hasUpperCase = /[A-Z]/.test(input);
    const hasLowerCase = /[a-z]/.test(input);
    const hasNumber = /[0-9]/.test(input);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(input);

    return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
};


  const handlePasswordUpdate = async () => {
    setErrorMsg();
    if (!validatePasswords()) {
        return;
    }

    if (!validatePassword(editedPassword.newPassword)) {
      setErrorMsg('Password must contain at least one Uppercase, one Lowercase, one number, and one special character.');
      setIsValid(false);

      return;
    }

    try {
        const updatePasswordData = {
            login_id: login_id,
			old_password:editedPassword.currentPassword,
            user_id: USER_ID,
            USER_NAME: USER_NAME,
            branchcode:BRANCH_CODE,
            type: usertype,
            new_password: editedPassword.newPassword,
            confirm_password: editedPassword.confirmPassword,
        };

        const response = await axios.post(BASE_URL + '/profilechangepassword', updatePasswordData);

        handleModalClose();
        Swal.fire({
            icon: "success",
            text: 'Password Updated Successfully.!'
        });
    } catch (error) {
        setErrorMsg(error.response.data.message);
    }
};

const validatePasswords = () => {
    if (!editedPassword.newPassword || !editedPassword.confirmPassword) {
        setErrorMsg("Please fill in all fields!");
        return false;
    }

    if (editedPassword.newPassword !== editedPassword.confirmPassword) {
        setErrorMsg("password and confirm password do not match");
        return false;
    }

    return true;
};

  const isLoginPage = ['/', '/Login', '/login','/notfount'].includes(location.pathname.trim().toLowerCase());

  if (isLoginPage) {
    return null;
  }
  
  if (location.pathname === '/Forgot_Password' || location.pathname === '/Forgot_Password') {
    return null; // Do not render breadcrumbs on the login page
  }
  
  if (location.pathname === '/ProductDetails_INLUDE' || location.pathname === '/siso') {
    return null;
  }

  
  
  const handleSearchChange = (e) => {
    const value = e.target.value.trim(); // Trim whitespace
    setSearchText(value);
  
    if (value === "") {
      setFilteredList(data); // Show all data when search is cleared
      setShowList(false); // Hide the dropdown if needed
      return;
    }
  
    const filtered = data.filter((item) =>
      item.urlname.toLowerCase().includes(value.toLowerCase())
    );
  
    if (filtered.length > 0) {
      setFilteredList(filtered);
      setShowList(true);
    } else {
      setFilteredList([{ urlname: "No results found", urlpath: "", icon: "" }]);
      setShowList(true);
    }
  };
 
  
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ height: '60px' }}>
        <Toolbar sx={{ height: '100%', backgroundImage: 'linear-gradient(to left, #00ccff 0%, var(--bs-gray) 100%)' }}>
          <div style={{  borderRadius: '25px', width: '62px' }}>
           
			  <img src={Crilogo} alt={"CRIlogo"}  style={{ height: '63px', width: '54px',borderRadius:'38px' }}  />
          </div>
          &emsp;
          <center  ><h5>{currentDirectoryName.toUpperCase()}</h5></center>
          <Box display="flex" alignItems="center" flexGrow={1}>
  {location.pathname !== '/ForgetPassword' &&
   location.pathname !== '/ResetPassword' &&
   location.pathname !== '/notfound' && (
    <>
   <div
      ref={dropdownRef} // Attach ref to parent div
      style={{ position: "relative", width: "180px", marginLeft: "auto" }}
    >
      <TextField
    id="search-field"
    placeholder="Search..."
    variant="outlined"
    size="small" // ✅ Make TextField compact
    sx={{
      backgroundColor: 'whitesmoke',
      borderRadius: '6px',
      '& fieldset': { border: 'none' }, // Remove outer border
      '& input': { padding: '6px 8px' }, // Small padding for smaller height
    }}
    value={searchText}
    onChange={handleSearchChange}
    fullWidth
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton size="small"> {/* Smaller icon button */}
            <SearchIcon fontSize="small" /> {/* Smaller icon */}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />

      {showList && filteredList.length > 0 && (
        <Paper
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            right: 0,
            zIndex: 10,
            maxHeight: "300px",
            width:"150%",
            overflowY: "auto",
            marginTop: "4px",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            backgroundColor: "#fff",
          }}
        >
            <List sx={{ padding: 0 }}>
      {filteredList.map((item, index) => (
        <ListItem
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 12px",
            transition: "background-color 0.2s, color 0.2s",
            "&:hover": {
              backgroundColor: "lightblue",
              cursor: "pointer",
              "& i": { color: "#1976d2" },
              "& span": { color: "#1976d2", fontWeight: 500 },
            },
          }}
          onClick={() => handleClick(item.urlpath, item.newtab)} // Pass newtab condition
        >
          <i
            className={(item.icon || "").trim()}
            style={{ fontSize: "16px", color: "#555" }}
          ></i>
          <span style={{ fontSize: "13px" }}>
            {(item.urlname || "").trim()}
          </span>
        </ListItem>
      ))}
    </List>
        </Paper>
      )}
    </div>
 <Button
  id="notification-menu-button"
  aria-controls="notification-menu"
  aria-haspopup="true"
  aria-expanded={isMenuOpen ? "true" : undefined}
  style={{ 
    color: "white", 
    marginLeft: "10px", 
    position: 'relative',
    minWidth: '40px'
  }}
  onClick={handleMenuOpen}
>
  <Badge 
    badgeContent={unreadCount} 
    color="error"
    overlap="circular"
    invisible={unreadCount === 0}
  >
    <CircleNotificationsIcon />
  </Badge>
</Button>

   <Menu
  id="notification-menu"
  anchorEl={menuAnchor}
  open={isMenuOpen}
  onClose={handleMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
  sx={{
    minWidth: 320,
    maxWidth: 400,
    maxHeight: '500px',
  }}
  PaperProps={{
    sx: {
      width: "100%",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    },
  }}
>
  <Typography 
    variant="subtitle1" 
    sx={{
      padding: '12px 16px',
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #e0e0e0',
      fontWeight: 'bold',
      position: 'sticky',
      top: 0,
      zIndex: 1,
      background: 'white'
    }}
  >
    Notifications ({unreadCount})
  </Typography>
  
  {notifications.length === 0 ? (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        padding: "16px",
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircleNotificationsIcon sx={{ fontSize: 40, color: 'action.disabled', mb: 1 }} />
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        No new notifications
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.disabled' }}>
        You're all caught up!
      </Typography>
    </Box>
  ) : (
    <List sx={{ 
      width: '100%',
      maxHeight: '400px',
      overflow: 'auto',
      padding: 0
    }}>
      {notifications.map((notification, index) => (
        <MenuItem
          key={index}
          sx={{
            padding: "12px 16px",
            borderBottom: '1px solid #f0f0f0',
            whiteSpace: 'normal',
            '&:hover': {
              backgroundColor: '#f5f5f5'
            }
          }}
          onClick={() => handleNotificationClick(notification)}
        >
          <Box sx={{ width: '100%' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
              {/* {notification.Title || 'New Notification'} */}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', mb: 1 }}>
              {notification.message}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Order #: {notification.doc_number}
              </Typography>
              {notification.status === "0" && (
                <Box sx={{
                  backgroundColor: 'primary.main',
                  color: 'white',
                  borderRadius: '4px',
                  padding: '0 4px',
                  fontSize: '0.7rem'
                }}>
                  New
                </Box>
              )}
            </Box>
          </Box>
        </MenuItem>
      ))}
    </List>
  )}
</Menu>



      <Button
        id="profile-menu-button"
        aria-controls="profile-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleProfileMenuOpen}
        style={{ color: 'white', marginLeft: '10px' }}
      >
        <AccountCircleIcon />
      </Button>
    </>
  )}
</Box>

          <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      open={open}
      onClose={handleProfileMenuClose}
      PaperProps={{
        style: {
          backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
        },
      }}
    >
      {userProfile && (
        <Card
          className="p-2"
          style={{
            width: '300px', // Set a fixed width for better layout
            padding: '20px',
            borderRadius: '8px',
            backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
            color: 'black', // Text color
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
            textAlign: 'center', // Center-align text
          }}
        >
     <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}  >

     {profileImage.images ? (
                                    <Avatar  style={{ backgroundColor: getColorForLetter(userProfile.USER_NAME.charAt(0)) ,
                                      width: '60px', 
                                      height: '60px', 
                                      fontSize: '44px' 
                                    }}
                                        sx={{
                                            height: "50px",
                                            width: "50px",
                                        }}
                                        src={`data:image/png;base64,${profileImage.images}`}
                                        alt="Profile Image"
                                    />
                                ) : (
                                    <Avatar  style={{ backgroundColor: getColorForLetter(userProfile.USER_NAME.charAt(0)) ,
                                      width: '60px', 
                                      height: '60px', 
                                      fontSize: '44px' 
                                    }}
                                        sx={{
                                            height: "50px",
                                            width: "50px",
                                        }}
                                    >
                                        {userProfile.USER_NAME.charAt(0)}
                                    </Avatar>
                                )}

  {/* <Avatar style={{ backgroundColor: getColorForLetter(userProfile.USER_NAME.charAt(0)) ,
    width: '60px', 
    height: '60px', 
    fontSize: '44px' 
  }}>
    {userProfile.USER_NAME.charAt(0)}
  </Avatar> */}
</div>
          <div className="row" style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              <span>{userProfile.USER_NAME}</span>
            </div>
            <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              <span>{userProfile.USER_ID}</span>
            </div>
            <div style={{ fontWeight: 'bold', marginTop: '10px' }}>
              <Button
                onClick={handleUpdatePasswordClick}
                style={{ backgroundColor: '#1f7f9c', color: 'white' }}
              ><ChangeCircleIcon/>
                 Change Password
              </Button>
            </div>
          </div>
        </Card>
      )}
      <MenuItem onClick={handleLogout} style={{ color: 'white', fontWeight: 'bold' }}>
        <LogoutOutlinedIcon /> Log Out
      </MenuItem>
    </Menu>
        </Toolbar>
      </AppBar>

      {/* Password Update Modal */}
      <Modal
  open={openModal}
  onClose={handleModalClose}
  aria-labelledby="password-update-modal"
  aria-describedby="password-update-modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 8,
    }}
  >
    <Card
      className="shadow rounded"
      sx={{
        width: '100%',
        height: '60px',
        fontWeight: 'bold',
        textDecoration: 'underline',
        backgroundColor: '#61d1e5',
        color: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h5">Change Password</Typography>
    </Card>

    <div className="col">
  <CustomTextField
    label="Current password"
    name="Current password"
    type={showCurrentPassword ? 'text' : 'password'}
    value={editedPassword.currentPassword}
    onChange={(e) =>
      setEditedPassword({ ...editedPassword, currentPassword: e.target.value })
    }
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <span onClick={toggleCurrentPasswordVisibility} style={{ cursor: 'pointer' }}>
            {showCurrentPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        </InputAdornment>
      ),
    }}
  />
</div>

<div className="col">
  <CustomTextField
    label="New password"
    name="New password"
    type={showNewPassword ? 'text' : 'password'}
    value={editedPassword.newPassword}
    onChange={(e) =>
      setEditedPassword({ ...editedPassword, newPassword: e.target.value })
    }
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <span onClick={toggleNewPasswordVisibility} style={{ cursor: 'pointer' }}>
            {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        </InputAdornment>
      ),
    }}
  />
</div>

<div className="col">
  <CustomTextField
    label="Confirm password"
    name="Confirm password"
    type={showConfirmPassword ? 'text' : 'password'}
    value={editedPassword.confirmPassword}
    onChange={(e) =>
      setEditedPassword({ ...editedPassword, confirmPassword: e.target.value })
    }
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <span
            onClick={toggleConfirmPasswordVisibility}
            style={{
              cursor: 'pointer',
              
            }}
          >
            {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        </InputAdornment>
      ),
    }}
  />
</div>

    <div className="row mt-2">
      <center>{errorMsg && <span style={{ color: 'red' }}>* {errorMsg}</span>}</center>
    </div>

    <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
      <CustomButton
        label="Update Password"
        onClick={handlePasswordUpdate}
        variant="outlined"
        fullWidth
      />
      <CustomButton
        label="Cancel"
        onClick={handleModalClose}
        variant="outlined"
        color="error"
        fullWidth
      />
    </Stack>
  </Box>
</Modal>
    </Box>
  );
}
